import React, { useState, useEffect, useRef, memo, useCallback } from "react";

import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import LinearProgress from "@material-ui/core/LinearProgress";
import "./dragAndDrop.css";

function DragAndDrop({
  handleFile,
  typesAccept = "image/png, image/jpeg, image/jpg",
  multiple = true,
  loading = false,
}) {
  const [dragging, setDragging] = useState(false);
  const dropRef = useRef(null);
  const [dragCounter, setDragCounter] = useState(0);

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDragIn = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter((prev) => prev++);
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setDragging(true);
    }
  }, []);

  const handleDragOut = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragCounter((prev) => prev--);
      if (dragCounter - 1 > 0) return;
      setDragging(false);
    },
    [dragCounter]
  );

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragging(false);
      if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        handleFile(e.dataTransfer.files);
        e.dataTransfer.clearData();
        setDragCounter(0);
      }
    },
    [handleFile]
  );

  const handleSelectImage = (e) => {
    if (!e.target.files[0]) return;

    handleFile(e.target.files);
  };

  useEffect(() => {
    setDragCounter(0);

    const div = dropRef.current;

    if (div) {
      div.addEventListener("dragenter", handleDragIn);
      div.addEventListener("dragleave", handleDragOut);
      div.addEventListener("dragover", handleDrag);
      div.addEventListener("drop", handleDrop);
    }
  }, [handleDragOut, handleDrop, handleDrag, handleDragIn]);

  return (
    <>
      {loading && (
        <>
          <label>Carregando imagens...</label>
          <LinearProgress />
        </>
      )}
      <div
        className={loading ? "display-none" : "container-drag-drop"}
        ref={dropRef}
      >
        <div>
          {dragging ? (
            <div className="dragging">
              <label>Solte aqui</label>
            </div>
          ) : (
            <div className="no-dragging">
              <label>
                <input
                  className="input-file"
                  accept={typesAccept}
                  type="file"
                  name="logomarca"
                  onChange={handleSelectImage}
                  value=""
                  multiple={multiple}
                />
                Arraste e solte um arquivo ou clique aqui
                <div>
                  <CloudUploadIcon className="icon-cloud" />
                </div>
              </label>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default memo(DragAndDrop);
